import { Component, Inject, OnInit, Injectable } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-messages',
  templateUrl: './dialog-messages.component.html',
  styleUrls: ['./dialog-messages.component.css']
})
export class DialogMessagesComponent implements OnInit {

  icons: any = {
    success: { icon: 'check_circle' },
    info: { icon: 'info' },
    danger: { icon: 'error' },
    warning: { icon: 'warning' },
    question: { icon: 'help' }
  }

  constructor(
    private dialogRef: MatDialogRef<DialogMessagesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  public closeMe() {
    this.dialogRef.close();
  }

}
